import React from 'react';
import { CheckCircle2, HardHat } from 'lucide-react';
export function ContractGlazing() {
  const exteriorPoints = ['Aluminum curtain walls', 'Exterior glass walls and lobbies', 'Slope glazing and specialty exterior glass', 'Total storefront systems', 'Ribbon windows and preglazed systems'];
  const contractPoints = ['Accurate commercial glass quotes and bid support', 'Fabrication and installation services', 'Custom hardware and glazing solutions', 'On-time project coordination for builders and owners', 'Service and maintenance for new and existing buildings'];
  return <section className="py-20 bg-navy-900 relative overflow-hidden border-t border-navy-800" data-id="element-484">
      <div className="absolute inset-0 bg-glass-grid opacity-10 pointer-events-none" data-id="element-485"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-486">
        <div className="max-w-3xl mb-14 anim-on-scroll" data-id="element-487">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary-500/15 text-primary-300 text-xs font-semibold uppercase tracking-wider mb-4" data-id="element-488">
            Contract Glazing
          </div>
          <h2 className="kosins-heading text-4xl md:text-5xl text-white mb-6" data-id="element-489">
            Curtain Walls, Exterior Glazing & Contract Glazing
          </h2>
          <p className="text-lg text-slate-300 leading-relaxed" data-id="element-490">
            Kosin’s Glass supports commercial construction and renovation with
            curtain wall systems, exterior glazing and full contract glazing
            services for builders, general contractors, architects and building
            owners across Michigan.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6" data-id="element-491">
          <div className="bg-navy-800/50 border border-navy-700 rounded-2xl p-8 backdrop-blur-sm scroll-fade-up" style={{
          animationDelay: '0s'
        }} data-id="element-492">
            <div className="flex items-center gap-3 mb-6" data-id="element-493">
              <div className="w-10 h-10 bg-primary-500/15 rounded-lg flex items-center justify-center" data-id="element-494">
                <HardHat className="w-5 h-5 text-primary-300" data-id="element-495" />
              </div>
              <h3 className="kosins-heading text-2xl text-white" data-id="element-496">
                Exterior Glazing Systems
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-497">
              {exteriorPoints.map((p, i) => <li key={i} className="flex items-start gap-3" data-id="element-498">
                  <CheckCircle2 className="w-5 h-5 text-primary-400 shrink-0 mt-0.5" data-id="element-499" />
                  <span className="text-slate-200" data-id="element-500">{p}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-navy-800/50 border border-navy-700 rounded-2xl p-8 backdrop-blur-sm scroll-fade-up" style={{
          animationDelay: '0.1s'
        }} data-id="element-501">
            <div className="flex items-center gap-3 mb-6" data-id="element-502">
              <div className="w-10 h-10 bg-amber-500/15 rounded-lg flex items-center justify-center" data-id="element-503">
                <CheckCircle2 className="w-5 h-5 text-amber-400" data-id="element-504" />
              </div>
              <h3 className="kosins-heading text-2xl text-white" data-id="element-505">
                Contract Glazing Capabilities
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-506">
              {contractPoints.map((p, i) => <li key={i} className="flex items-start gap-3" data-id="element-507">
                  <CheckCircle2 className="w-5 h-5 text-primary-400 shrink-0 mt-0.5" data-id="element-508" />
                  <span className="text-slate-200" data-id="element-509">{p}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 text-center anim-on-scroll" data-id="element-510">
          <a href="#quote-form" className="inline-flex items-center justify-center bg-primary-600 hover:bg-primary-500 text-white font-semibold py-3.5 px-8 rounded-lg transition-colors" data-id="element-511">
            Request a Contract Glazing Bid
          </a>
        </div>
      </div>
    </section>;
}